<template>
  <div>
    <!-- 查询 -->
    
    <div style="text-align:right">
      <monthQuickQuery :size="size" :isNow="false" @handleQuery="handleQuery" @quickQuery="quickQuery"
        @download="download" :downloading="downloading" style="text-align: right" />
    </div>
    <!-- 表格 -->
    <div class="page_container_a">
      <!-- <el-table-column label="车型" align="center" prop="vehicleModel" min-width="150" fixed="left"></el-table-column>
        <el-table-column label="车号" align="center" prop="manufactureID" min-width="95" fixed="left"></el-table-column> -->
      <el-table id="table_monSta" :data="dataList" border :size="size" :span-method="objectSpanMethod"
        :cell-style="cellStyle" v-loading="loading">
        <!-- :show-summary="showSum"
        :summary-method="getSummaries" -->
        <el-table-column :label="$t('runState.carNo')" align="center" prop="carNo" min-width="110"
          fixed="left"></el-table-column>
        <el-table-column :label="$t('runState.statMonth')" align="center" prop="statDate" min-width="110"
          fixed="left"></el-table-column>
        <el-table-column :label="$t('runState.runDays')" align="center" prop="runDays"
          min-width="100"></el-table-column>
        <el-table-column :label="$t('runState.runDuration')" align="center" prop="runDuration" min-width="120">
          <template slot-scope="scope">{{ fixed2(scope.row.runDuration) }}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.driveDuration')" align="center" prop="driveDuration" min-width="120">
          <template slot-scope="scope">{{ fixed2(scope.row.driveDuration) }}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.driveRatio')" align="center" prop="driveRatio" min-width="120">
          <template slot-scope="scope">{{ fixed2(scope.row.driveRatio * 100) }} %</template>
        </el-table-column>
        <el-table-column :label="$t('runState.idleDuration')" align="center" prop="idleDuration" min-width="120">
          <template slot-scope="scope">{{ fixed2(scope.row.idleDuration) }}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.idleRatio')" align="center" prop="idleRatio" min-width="120">
          <template slot-scope="scope">{{ fixed2(scope.row.idleRatio * 100) }} %</template>
        </el-table-column>
        <el-table-column :label="$t('runState.airDuration')" align="center" prop="airDuration" min-width="150">
          <template slot-scope="scope">{{ fixed2(scope.row.airDuration) }}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.airRatio')" align="center" prop="airRatio" min-width="150">
          <template slot-scope="scope">{{ fixed2(scope.row.airRatio * 100) }} %</template>
        </el-table-column>
        <el-table-column :label="$t('runState.heaterDuration')" align="center" prop="heaterDuration" min-width="165">
          <template slot-scope="scope">{{ fixed2(scope.row.heaterDuration) }}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.heaterRatio')" align="center" prop="heaterRatio" min-width="165">
          <template slot-scope="scope">{{ fixed2(scope.row.heaterRatio * 100) }} %</template>
        </el-table-column>
        <el-table-column :label="$t('runState.minSpeed')" align="center" prop="minSpeed"
          min-width="150"></el-table-column>
        <el-table-column :label="$t('runState.maxSpeed')" align="center" prop="maxSpeed"
          min-width="150"></el-table-column>
        <el-table-column :label="$t('runState.avgSpeed')" align="center" prop="avgSpeed"
          min-width="150"></el-table-column>
        <el-table-column :label="$t('runState.mileage')" align="center" prop="runMileage"
          min-width="120"></el-table-column>
        <el-table-column :label="$t('runState.oilConsume')" align="center" prop="oilConsume"
          min-width="110"></el-table-column>
        <el-table-column :label="$t('runState.perOilConsume')" align="center" prop="perOilConsume"
          min-width="100"></el-table-column>
        <el-table-column :label="$t('runState.elecConsume')" align="center" prop="elecConsume"
          min-width="100"></el-table-column>
        <el-table-column :label="$t('runState.perElecConsume')" align="center" prop="perElecConsume"
          min-width="110"></el-table-column>
      </el-table>
      <!-- <el-table-column label="功耗百分比" align="center" prop="elecConsumePercent" min-width="110"></el-table-column> -->
    </div>
    <kl-pagination :total="total" :currentPage="currentPage" @current-change="currentchange"></kl-pagination>
  </div>
</template>
<script>
import monthQuickQuery from '@/views/statistics/operationalData/components/monthQuickQuery'
import { mapState } from "vuex";
import language from '@/utils/getLanguageId'
export default {
  props: {
    size: {
      type: String,
    },
    isClicked: {
      type: Boolean,
      default: false,
    }
  },
  components: { monthQuickQuery },
  watch: {
    // 合并合计行的合计
    dataList: {// 表格数据
      immediate: true,
      handler() {
        setTimeout(() => {
          // const tds = document.querySelectorAll('#table .el-table__footer-wrapper tr>td');//表格没有固定列时 写法
          const tds = document.querySelectorAll('#table_monSta .el-table__fixed-footer-wrapper tr>td');//表格有固定列时 写法
          // console.log(tds);
          if (tds.length > 0) {
            tds[0].colSpan = 2;
            tds[0].style.textAlign = 'center';
            tds[0].style.background = '#E8F0FF';
            tds[1].style.display = 'none';
          }
        }, 0)
      }
    },
    // tabs点击才进行初次加载
    isClicked(newVal) {
      if (newVal) {
        this.getList();
      }
    }
  },
  data() {
    return {
      downloading: false,
      loading: false,
      pageSize: 10,
      currentPage: 1,
      total: 0,
      vehicles: "",
      form: undefined,
      needMergeArr: ["carNo", "statDate"],
      rowMergeArrs: [],
      dataList: [],
      showSum: true, //是否展示合计行
      LanguageId: 1,
    }
  },
  computed: {
    ...mapState({
      operator: (state) => state.user.operator,
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
    list() {
      if (this.dataList != null && this.dataList.length > 0) {
        return this.dataList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
      }
      return [];
    },
  },
  methods: {
    fixed2(val) {
      if (val == 0 || val == null || val == undefined || val == "") {
        return 0;
      }
      if (Number.isInteger(val)) return val;
      return val.toFixed(2)
    },
    currentchange(page) {
      this.currentPage = page;
      this.getList();
    },
    getSelectedVehicles() {
      this.vehicles = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0, this.vehicles.length - 1);
    },
    // 给小结单元格添加背景色
    cellStyle({ row, columnIndex }) {
      if (row.carNo == "小结" && columnIndex == 0) {
        return 'background:#E8F0FF'
      }
      if (columnIndex < 2) {
        return 'background:rgb(238, 244, 255)'
      }
    },
    getList() {
      this.loading = true;
      this.$api.runStateInfo({
        vehicles: this.vehicles,
        queryType: 0,
        beginDate: this.form.beginDate,
        endDate: this.form.endDate,
        OperatorID: this.operator.OperatorId + "",
        PageNo: this.currentPage,
        PageSize: 10,
        IsExport: 0, // 0是查询 1是下载
        Language: this.LanguageId,
      })
        .then((res) => {
          if (res && res.code == 200) {
            this.dataList = res.data;
            this.total = res.count;
            if (this.total == 0) {
              this.showSum = false;
            }
            // console.log(this.showSum);
            this.loading = false;
          }
        })
        .catch((e) => {
          this.loading = false;
          this.dataList = [];
          this.total = 0;
        })
    },
    quickQuery(form) {
      this.form = form;
      // console.log(this.form);
      this.currentPage = 1;
      this.vehicles = this.getSelectedVehicles();
      this.getList();
    },
    handleQuery(form) {
      this.form = form;
      this.currentPage = 1;
      this.vehicles = this.getSelectedVehicles();
      if (this.form.beginDate == "" || this.form.beginDate == null || this.form.beginDate == undefined) {
        this.$message({
          message: this.$t("runState.select_search_date"),//'请选择查询时间',
          type: 'warning'
        });
        return;
      }
      if (this.isClicked) {
        this.getList();
      }
    },
    download() {
      this.vehicles = this.getSelectedVehicles();
      var that = this;
      that.downloading = true;

      this.$api.downRunStateInfo({
        vehicles: this.vehicles,
        queryType: 0,
        beginDate: this.form.beginDate,
        endDate: this.form.endDate,
        OperatorID: this.operator.OperatorId + "",
        IsExport: 1, // 0是查询 1是下载
        Language: this.LanguageId,
      })
        .then((res) => {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码
          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.setAttribute(
            "download",
            that.$t("runState.monthSta") + that.$t("public.download") + `_${that.timestampToTime(new Date().getTime())}.xlsx`
          ); // 表名，自定义
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          that.downloading = false;
        })
        .catch((error) => {
          console.error("下载失败", error);
          that.downloading = false;
        });
    },
    //时间戳转换为日期格式
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
      var Y = date.getFullYear();
      var M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var D = date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j == "runDuration") {
          return this.fixed2(v[j]);
        } else if (j == "driveDuration") {
          return this.fixed2(v[j]);
        } else if (j == "driveRatio") {
          return this.fixed2(v[j] * 100) + " %";
        } else if (j == "idleDuration") {
          return this.fixed2(v[j]);
        } else if (j == "idleRatio") {
          return this.fixed2(v[j] * 100) + " %";
        } else if (j == "airDuration") {
          return this.fixed2(v[j]);
        } else if (j == "airRatio") {
          return this.fixed2(v[j] * 100) + " %";
        } else if (j == "heaterDuration") {
          return this.fixed2(v[j]);
        } else if (j == "heaterRatio") {
          return this.fixed2(v[j] * 100) + " %";
        } else {
          return v[j]
        }
      }))
    },
    // 合计行计算全部数据而不是当页合计
    getSummaries(param) {
      let data = this.dataList;
      let goSum;
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t("runState.tableSum")//"小结";
          return;
        }
        //把中间小结的数据不算进最后合计
        goSum = data.filter(item => {
          return item.statDate != "小结"
        })
        const values = goSum.map(item => Number(item[column.property]));
        sums[index] = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
        if (!Number.isInteger(sums[index])) {
          sums[index] = sums[index].toFixed(2);
        }
        if (index === 7 || index === 9 || index === 11 || index === 5) {
          sums[index] = this.fixed2((sums[index] * 100) / this.total) + "%";
        }
      });
      return sums;
    },


    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 获取表格数据
      const data = this.dataList;
      // 合并 carNo 列
      if (columnIndex === 0) {
        if (rowIndex > 0 && row.carNo === data[rowIndex - 1].carNo) {
          return { rowspan: 0, colspan: 0 };  // 合并当前和上一行的 carNo
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < data.length; i++) {
            if (data[i].carNo === row.carNo) {
              rowspan++;
            } else {
              break;
            }
          }
          return {
            rowspan: rowspan, // 合并的行数
            colspan: 1 // carNo 列合并
          };
        }
      }

      // 其他列的处理
      return {
        rowspan: 1,
        colspan: 1
      };
    },

  },
  mounted() {
    this.LanguageId = language(this.$store.getters.locale)
  }
}
</script>
<style lang="scss" scoped>
.page_container_a {
  margin-top: 10px;

  ::v-deep .el-table tr {
    background: rgb(244, 248, 255);
  }

  ::v-deep .el-table {
    background: rgb(244, 248, 255);
  }

  ::v-deep .el-table td {
    background: rgb(244, 248, 255);
  }

}

::v-deep .el-table {
  .el-table__body-wrapper {
    z-index: 1;
  }
}

::v-deep .el-table__fixed,
.el-table__fixed-left {
  // background: rgb(244, 248, 255)!important;
  background: rgb(238, 244, 255) !important;
}

::v-deep .el-table__fixed-right {
  background-color: #f5f9ff !important;
}
</style>